export function makeLinkActive(link) {
    const links = document.getElementsByClassName('mobile-link')
    for (let l of links) {
        l.classList.remove('active')
    }
    const el = document.getElementById(link)
    if (el) {
        document.getElementById(link).classList.add('active')
    }
}